export type ShipInfo = {
  Id: number;
  Code: string;
  Name: string;
  ImageBase64: string;
  Description: string;
};

export type ShipPlacesInfo = {
  ShipId: number;
  ShipName: string;
  PlaceId: number;
  PlaceCode: string;
  PlaceName: string;
  Type: string;
  Date: Date;
  EventId: number;
};

export type DocumentTypeInfo = {
  Key: string;
  Value: string;
};

export type GenderInfo = {
  Key: string;
  Value: string;
};

export type NationalityInfo = {
  Code: string;
  Name: string;
};

export type VisitInfo = {
  Id: number;
  ShipName: string;
  VisitStartDate: Date;
  VisitEndDate: Date;
  Port: string;
  Status: string;
  Visitors: VisitorData[];  
};

export type AddVisitInfo = {
  EventId: number;
  AgentId: number;
  VisitStartDate: Date;
  VisitEndDate: Date;
  Visitors: VisitorData[];  
};

export type VisitorData = {
  Id: number;
  FolioId: number;
  Forename: string;
  Surname: string;
  BirthDate: Date | null;
  Gender: string;
  Address: string;
  City: string;
  Email: string;
  Phone: string;
  Nationality: string;
  TravelerComments: string;
  ContactPerson: string;
  LicensePlate: string;
  VisitorFunction: string;
  DocumentType: string;
  DocumentNumber: string;
  DocumentForename: string;
  DocumentSurname: string;
  DocumentAddress: string;
  DocumentValidDate: Date | null;
};

export function createVisitorDef(visitorId: number): VisitorData
{
  return {
    Id: visitorId,
    FolioId: 0,
    Forename: "",
    Surname: "",
    BirthDate: null,
    Gender: "",
    Address: "",
    City: "",
    Email: "",
    Phone: "",
    Nationality: "",
    TravelerComments: "",
    ContactPerson: "",
    LicensePlate: "",
    VisitorFunction: "",
    DocumentType: "",
    DocumentNumber: "",
    DocumentForename: "",
    DocumentSurname: "",
    DocumentAddress: "",
    DocumentValidDate: null
  };
}